var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_17371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9989 0C17.9076 0 0 17.9076 0 39.9989C0 62.0902 17.9076 79.9978 39.9989 79.9978C62.0902 79.9978 79.9978 62.0902 79.9978 39.9989C79.9978 17.9076 62.0902 0 39.9989 0ZM43.4682 69.191C43.5098 68.7834 43.7268 66.7759 44.3032 63.8961C44.9497 60.6591 46.8279 62.6666 52.719 62.9252C58.61 63.1838 57.0561 58.4588 56.9268 57.6172C56.7975 56.7756 55.8266 55.2218 56.9926 54.5095C58.1585 53.7972 57.7684 52.7628 57.7684 52.7628C57.7684 52.7628 57.3147 51.987 57.8977 51.5333C58.4807 51.0796 58.4149 50.8868 58.027 49.3965C57.6391 47.9084 58.3514 47.2597 60.2931 45.7716C62.2349 44.2835 59.7759 42.0174 57.8342 40.2334C55.8924 38.4494 55.3752 34.5725 55.568 30.8183C55.7609 27.0641 51.9344 19.5688 43.0693 16.9652C32.2647 13.7939 14.916 18.7119 16.5992 38.3267C17.4671 48.4475 22.8124 48.1013 24.3027 54.5752C25.3722 59.2214 24.6051 61.7001 24.0879 62.7302C16.3647 56.8874 11.3722 47.6235 11.3722 37.1915C11.37 19.5162 25.6965 5.18752 43.3718 5.18752C61.047 5.18752 75.3735 19.5162 75.3735 37.1893C75.3735 54.8623 61.0974 69.1384 43.4682 69.1888V69.191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_17371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b36861558b1edaf4b00767bba94e2ab4.svg";
export { ForwardRef as ReactComponent };